import React from 'react';
import { Constrain, ControlLink, Expandable, Stack } from '@moda/om';
import { SiteFooterMailingList } from '../SiteFooterMailingList';
import { SiteFooterLinksMobile } from '../SiteFooterLinks';
import { hrefFor } from '../../../routers';
import { SiteFooterMobileClientServices } from './SiteFooterMobileClientServices';

import './SiteFooterMobile.scss';

export const SiteFooterMobile: React.FC = () => (
  <Constrain className="SiteFooterMobile">
    <SiteFooterMobileClientServices />

    <Expandable className="SiteFooterMobile__more" name="MORE INFORMATION">
      <SiteFooterLinksMobile />
    </Expandable>

    <a
      className="SiteFooterMobile__download"
      href="https://itunes.apple.com/us/app/moda-operandi/id781702094"
    >
      Download the Moda App
    </a>

    <div className="SiteFooterMobile__sign-up">
      <SiteFooterMailingList />
    </div>

    <Stack alignItems="flex-start" className="SiteFooterMobile__terms-and-privacy" space={2}>
      <ControlLink to={hrefFor.TermsAndConditionsPage()} underlined={false}>
        Terms & Conditions
      </ControlLink>

      <ControlLink to={hrefFor.PrivacyPolicyPage()} underlined={false}>
        Privacy Policy
      </ControlLink>
    </Stack>

    <div className="SiteFooterMobile__basement">
      © {new Date().getFullYear()} Moda Operandi, Inc. All Rights Reserved.
    </div>
  </Constrain>
);
